(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("3gZOF", function(module, exports) {

$parcel$export(module.exports, "useDelayedRegister", function () { return $2622d11dde432ca2$export$e974de1708ed4507; });
$parcel$export(module.exports, "useAnchors", function () { return $2622d11dde432ca2$export$c241e39743bf2be1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $cHs0A = parcelRequire("cHs0A");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $58Tj9 = parcelRequire("58Tj9");

var $kQvlq = parcelRequire("kQvlq");

var $biidj = parcelRequire("biidj");

var $hBcYV = parcelRequire("hBcYV");

var $5y6Kk = parcelRequire("5y6Kk");

var $lx43R = parcelRequire("lx43R");
var $2622d11dde432ca2$export$827b61424e8f52d2 = {
    contents: {}
};
function $2622d11dde432ca2$export$e974de1708ed4507(hookResult, category) {
    var match = $kQvlq.useSafeTimeout(undefined, undefined);
    var $$setTimeout = match.setTimeout;
    var match$1 = $2whNH.getWithDefault(hookResult, $5y6Kk.empty);
    var registerSection = match$1.registerSection;
    $g85JO.useEffect(function() {
        $$setTimeout(function(param) {
            $iv6Yc._1(registerSection, category);
        }, 0);
    }, []);
}
function $2622d11dde432ca2$export$c241e39743bf2be1(enabledOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var store = $g85JO.useRef([]);
    var scrollToRef = $g85JO.useRef(function(param) {});
    var highlightRef = $g85JO.useRef(function(param) {});
    var offset = $g85JO.useRef([]);
    var match = $hBcYV.useRouter(undefined);
    var listPageType = match.listPageType;
    var route = match.route;
    var setCurrentHighlightedCategoryId = $g85JO.useCallback(function(categoryId) {
        $iv6Yc._1(highlightRef.current, categoryId);
    }, [
        highlightRef
    ]);
    var lockHighlightOnScroll = $g85JO.useRef(false);
    var match$1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var lockHighlightOnScrollTimeout = match$1.setTimeout;
    var viewPLP;
    if (typeof route === "number") viewPLP = false;
    else switch(route.TAG | 0){
        case /* Home */ 0:
            var match$2 = route._0;
            viewPLP = $2whNH.isSome(match$2.filters) || $2whNH.isSome(match$2.sort);
            break;
        case /* ListPage */ 1:
            viewPLP = route._0.viewPLP;
            break;
        default:
            viewPLP = false;
    }
    var getCurrentKey = function getCurrentKey(param) {
        return $2whNH.mapWithDefault(listPageType, "index", function(id) {
            if (typeof id === "number") switch(id){
                case /* Favorites */ 0:
                    return "favorites";
                case /* History */ 1:
                    return "history";
                case /* StoreCart */ 2:
                    return "store-cart";
            }
            else switch(id.TAG | 0){
                case /* Category */ 0:
                    return "category-" + id._0;
                case /* Product */ 1:
                    return "product-" + id._0;
                case /* StoreCategory */ 2:
                    return "store-category-" + id._0.categoryId;
            }
        }) + (viewPLP ? "-plp" : "-clp");
    };
    var getSectionElement = function getSectionElement(category) {
        return $loT9g.nullable_to_opt(document.querySelector("#sn-section-container-" + category.id + ""));
    };
    var getFromMemory = function getFromMemory(category) {
        return $i7mYY.getBy(store.current, function(data) {
            return data.id === category.id;
        });
    };
    var calculate = function calculate(el, id, name) {
        var offsetTop = el.offsetTop;
        var __x = $2whNH.getWithDefault($loT9g.nullable_to_opt(el.parentElement), el);
        var marginTop = $2whNH.getWithDefault($cHs0A.fromString(window.getComputedStyle(__x).marginTop), 0);
        var topDistance = offsetTop - marginTop | 0;
        return {
            id: id,
            el: el,
            topDistance: topDistance,
            name: name
        };
    };
    var recalculateAllWithId = function recalculateAllWithId(id) {
        var fromMemory = $2whNH.getWithDefault($d3YYW.get($2622d11dde432ca2$export$827b61424e8f52d2.contents, id), []);
        var mod = $i7mYY.map(fromMemory, function(data) {
            return calculate(data.el, data.id, data.name);
        });
        $2622d11dde432ca2$export$827b61424e8f52d2.contents[id] = mod;
        if (getCurrentKey(undefined) === id) {
            store.current = mod;
            return;
        }
    };
    var recalculateOnZero = function recalculateOnZero(id) {
        var total = $i7mYY.reduce(store.current, 0, function(prev, curr) {
            return prev + curr.topDistance | 0;
        });
        if (total === 0) return recalculateAllWithId(id);
    };
    $g85JO.useEffect(function() {
        if (enabled) {
            var key = getCurrentKey(undefined);
            store.current = $2whNH.getWithDefault($d3YYW.get($2622d11dde432ca2$export$827b61424e8f52d2.contents, key), []);
            recalculateOnZero(key);
        }
    }, [
        listPageType,
        viewPLP
    ]);
    $biidj.useWindowResize(function(e) {
        if (enabled) return recalculateAllWithId(getCurrentKey(undefined));
    });
    var registerSectionByElement = $g85JO.useCallback(function(category) {
        return function(element) {
            if (!enabled) return;
            var data = $58Tj9.stableSortBy($i7mYY.concat($i7mYY.keep(store.current, function(t) {
                return t.id !== category.id;
            }), [
                calculate(element, category.id, category.title)
            ]), function(a, b) {
                if (b.topDistance > a.topDistance) return 1;
                else return -1;
            });
            store.current = data;
            $2622d11dde432ca2$export$827b61424e8f52d2.contents[getCurrentKey(undefined)] = data;
        };
    }, [
        store,
        $2622d11dde432ca2$export$827b61424e8f52d2,
        route
    ]);
    var registerSectionMaybe = $g85JO.useCallback(function(category) {
        if (!enabled) return;
        var el = getSectionElement(category);
        if (el !== undefined) return $iv6Yc._2(registerSectionByElement, category, $loT9g.valFromOption(el));
    }, [
        registerSectionByElement
    ]);
    var lockHighlightOnScrollForOneSecond = $g85JO.useCallback(function(param) {
        lockHighlightOnScroll.current = true;
        $lx43R.Jammer.jam(undefined);
        lockHighlightOnScrollTimeout(function(param) {
            lockHighlightOnScroll.current = false;
            $lx43R.Jammer.unjam(undefined);
        }, 1000);
    }, [
        lockHighlightOnScroll
    ]);
    var adjustTopDistance = function adjustTopDistance(topDistance) {
        return topDistance - $i7mYY.reduce(offset.current, 0, function(prev, curr) {
            return prev + curr | 0;
        }) | 0;
    };
    var previousEl = $g85JO.useRef(undefined);
    var onScrollElement = $g85JO.useCallback(function(el) {
        previousEl.current = previousEl.current === undefined ? el : previousEl.current;
        var isLocked = lockHighlightOnScroll.current;
        var isSameElement = $7bjme.equal(el, previousEl.current);
        if (el === undefined) return;
        if (!(enabled && !isLocked && isSameElement)) return;
        var top = $loT9g.valFromOption(el).scrollTop | 0;
        $iv6Yc._1(setCurrentHighlightedCategoryId, $2whNH.map($i7mYY.getBy(store.current, function(data) {
            return top >= adjustTopDistance(data.topDistance);
        }), function(data) {
            return data.id;
        }));
    }, [
        store,
        lockHighlightOnScroll,
        enabled,
        setCurrentHighlightedCategoryId
    ]);
    var onScrollDiv = $g85JO.useCallback(function(e) {
        return function(param) {
            return $iv6Yc._1(onScrollElement, e.target);
        };
    }, [
        onScrollElement
    ]);
    var onScrollWindow = $g85JO.useCallback(function(e) {
        $iv6Yc._1(onScrollElement, $loT9g.nullable_to_opt(document.getElementsByTagName("html").item(0)));
    }, [
        onScrollElement
    ]);
    var onClick = $g85JO.useCallback(function(category) {
        $iv6Yc._1(setCurrentHighlightedCategoryId, category.id);
        $iv6Yc._1(lockHighlightOnScrollForOneSecond, undefined);
        var memory = getFromMemory(category);
        var scrollToValue;
        if (memory !== undefined) scrollToValue = {
            TAG: /* Pixel */ 1,
            _0: adjustTopDistance(memory.topDistance)
        };
        else {
            var element = getSectionElement(category);
            if (element !== undefined) {
                var element$1 = $loT9g.valFromOption(element);
                $iv6Yc._2(registerSectionByElement, category, element$1);
                scrollToValue = {
                    TAG: /* Element */ 0,
                    _0: element$1
                };
            } else scrollToValue = undefined;
        }
        if (scrollToValue !== undefined) {
            $iv6Yc._1(scrollToRef.current, scrollToValue);
            return true;
        } else return false;
    }, [
        scrollToRef,
        registerSectionByElement
    ]);
    var setOffset = function setOffset(newOffset) {
        offset.current = newOffset;
    };
    return $g85JO.useMemo(function() {
        return {
            anchors: store.current,
            offset: offset.current,
            registerSection: registerSectionMaybe,
            highlightRef: highlightRef,
            scrollToRef: scrollToRef,
            setOffset: setOffset,
            onScrollDiv: onScrollDiv,
            onScrollWindow: onScrollWindow,
            onClick: onClick
        };
    }, [
        store.current,
        offset.current,
        registerSectionMaybe,
        highlightRef,
        scrollToRef,
        onScrollDiv,
        onScrollWindow,
        onClick
    ]);
}
 /* react Not a pure module */ 
});
parcelRegister("5y6Kk", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $40a55c5f9287649e$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE
var $40a55c5f9287649e$var$empty_anchors = [];
var $40a55c5f9287649e$var$empty_offset = [];
function $40a55c5f9287649e$var$empty_registerSection(param) {}
function $40a55c5f9287649e$var$empty_setOffset(param) {}
function $40a55c5f9287649e$var$empty_onScrollDiv(param, param$1) {}
function $40a55c5f9287649e$var$empty_onScrollWindow(param) {}
function $40a55c5f9287649e$var$empty_onClick(param) {
    return false;
}
var $40a55c5f9287649e$export$6e22c362a0406a2c = {
    anchors: $40a55c5f9287649e$var$empty_anchors,
    offset: $40a55c5f9287649e$var$empty_offset,
    registerSection: $40a55c5f9287649e$var$empty_registerSection,
    highlightRef: undefined,
    scrollToRef: undefined,
    setOffset: $40a55c5f9287649e$var$empty_setOffset,
    onScrollDiv: $40a55c5f9287649e$var$empty_onScrollDiv,
    onScrollWindow: $40a55c5f9287649e$var$empty_onScrollWindow,
    onClick: $40a55c5f9287649e$var$empty_onClick
};
var $40a55c5f9287649e$export$3a8840c5b2ecf003;
 /* No side effect */ 
});

parcelRegister("lx43R", function(module, exports) {

$parcel$export(module.exports, "Jammer", function () { return $facfd485086f448e$export$9b6002db3d45a06b; });
$parcel$export(module.exports, "useScrollable", function () { return $facfd485086f448e$export$79e8db7c10e50c32; });
$parcel$export(module.exports, "useWindow", function () { return $facfd485086f448e$export$24b8fbafc4b6a151; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ePG8R = parcelRequire("ePG8R");

var $7GW0c = parcelRequire("7GW0c");

var $2XXXw = parcelRequire("2XXXw");

var $3s6k1 = parcelRequire("3s6k1");
function $facfd485086f448e$export$f84e8e69fd4488a5(direction) {
    if (direction) return "Down";
    else return "Up";
}
var $facfd485086f448e$var$jammed = {
    contents: false
};
function $facfd485086f448e$var$jam(param) {
    $facfd485086f448e$var$jammed.contents = true;
}
function $facfd485086f448e$var$unjam(param) {
    $facfd485086f448e$var$jammed.contents = false;
}
function $facfd485086f448e$var$isJammed(param) {
    return $facfd485086f448e$var$jammed.contents;
}
var $facfd485086f448e$export$9b6002db3d45a06b = {
    jammed: $facfd485086f448e$var$jammed,
    jam: $facfd485086f448e$var$jam,
    unjam: $facfd485086f448e$var$unjam,
    isJammed: $facfd485086f448e$var$isJammed
};
function $facfd485086f448e$export$79e8db7c10e50c32(enabledOpt, element, initialDirectionOpt, thresholdOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var initialDirection = initialDirectionOpt !== undefined ? initialDirectionOpt : /* Up */ 0;
    var threshold = thresholdOpt !== undefined ? thresholdOpt : 5;
    var match = $ePG8R.use(undefined, undefined, function(param) {
        return initialDirection;
    });
    var setScrollDirection = match[1];
    var lastScrollPosition = $g85JO.useRef(0);
    var lastScrollDirection = $g85JO.useRef(/* Up */ 0);
    var onScroll = function onScroll(e) {
        if (!(enabled && !$2XXXw.isBlockingOnScrollEvent(undefined) && !$facfd485086f448e$var$jammed.contents)) return;
        var target = e.target;
        var scrollTop = target.scrollTop | 0;
        var nextDirection = scrollTop !== 0 ? (scrollTop - threshold | 0) > lastScrollPosition.current ? /* Down */ 1 : (scrollTop + threshold | 0) < lastScrollPosition.current ? /* Up */ 0 : lastScrollDirection.current : /* Up */ 0;
        $iv6Yc._1(setScrollDirection, function(param) {
            return nextDirection;
        });
        lastScrollPosition.current = scrollTop;
        lastScrollDirection.current = nextDirection;
    };
    var addListener = function addListener(element) {
        element.addEventListener("scroll", onScroll, {
            capture: false,
            passive: true,
            once: false
        });
    };
    var removeListener = function removeListener(element) {
        element.removeEventListener("scroll", onScroll, {
            capture: false,
            passive: true
        });
    };
    $g85JO.useEffect(function() {
        if (element === undefined) return;
        if (!enabled) return;
        var element$1 = $loT9g.valFromOption(element);
        removeListener(element$1);
        addListener(element$1);
        return function(param) {
            removeListener(element$1);
        };
    }, [
        element
    ]);
    return [
        match[0],
        setScrollDirection
    ];
}
function $facfd485086f448e$export$24b8fbafc4b6a151(enabledOpt, onScroll, initialDirectionOpt, thresholdOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var initialDirection = initialDirectionOpt !== undefined ? initialDirectionOpt : /* Up */ 0;
    var threshold = thresholdOpt !== undefined ? thresholdOpt : 5;
    var match = $ePG8R.use(undefined, undefined, function(param) {
        return initialDirection;
    });
    var setScrollDirection = match[1];
    var lastScrollPosition = $g85JO.useRef(0);
    var lastScrollDirection = $g85JO.useRef(/* Up */ 0);
    var onScroll$1 = function onScroll$1(e) {
        if (!(!$3s6k1.isBlockingOnScrollEvent(undefined) && !$facfd485086f448e$var$jammed.contents)) return;
        var scrollTop = $iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0;
        var nextDirection = scrollTop !== 0 ? (scrollTop - threshold | 0) > lastScrollPosition.current ? /* Down */ 1 : (scrollTop + threshold | 0) < lastScrollPosition.current ? /* Up */ 0 : lastScrollDirection.current : /* Up */ 0;
        $iv6Yc._1(setScrollDirection, function(param) {
            return nextDirection;
        });
        lastScrollPosition.current = scrollTop;
        lastScrollDirection.current = nextDirection;
        $2whNH.forEach(onScroll, function(cb) {
            $iv6Yc._2(cb, nextDirection, scrollTop);
        });
    };
    $g85JO.useEffect(function() {
        if (enabled) window.addEventListener("scroll", onScroll$1, {
            capture: false,
            passive: true,
            once: false
        });
        return function(param) {
            window.removeEventListener("scroll", onScroll$1, {
                capture: false,
                passive: true
            });
        };
    }, [
        enabled
    ]);
    return [
        match[0],
        setScrollDirection
    ];
}
 /* react Not a pure module */ 
});
parcelRegister("3s6k1", function(module, exports) {

$parcel$export(module.exports, "isBlockingOnScrollEvent", function () { return $2838e4065aa467f6$export$51e57029e6716073; });
$parcel$export(module.exports, "useGlobalScrollRestoration", function () { return $2838e4065aa467f6$export$6f91e7af12d0519b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $dLC6y = parcelRequire("dLC6y");

var $kQvlq = parcelRequire("kQvlq");

var $kJhYp = parcelRequire("kJhYp");

var $7GW0c = parcelRequire("7GW0c");

var $gO2mJ = parcelRequire("gO2mJ");

var $efwy1 = parcelRequire("efwy1");

var $25dxq = parcelRequire("25dxq");

var $2XXXw = parcelRequire("2XXXw");

var $hv3Nv = parcelRequire("hv3Nv");
$gO2mJ.setScrollRestoration("manual");
var $2838e4065aa467f6$var$blockingOnScrollEvent = {
    contents: false
};
function $2838e4065aa467f6$export$aded8d3ce7fe43e1(bool) {
    $2838e4065aa467f6$var$blockingOnScrollEvent.contents = bool;
}
function $2838e4065aa467f6$export$51e57029e6716073(param) {
    return $2838e4065aa467f6$var$blockingOnScrollEvent.contents;
}
function $2838e4065aa467f6$export$85c5d4ae50531531(fn) {
    var match = $kQvlq.useSafeTimeout(undefined, undefined);
    var $$clearTimeout = match.clearTimeout;
    var $$setTimeout = match.setTimeout;
    var lastScrollHeightRef = $g85JO.useRef(0);
    var ref = $hv3Nv.use(undefined, "body");
    var loop = function loop1(param) {
        $$setTimeout(function(param) {
            var el = ref.current;
            if (!(el == null) && el.scrollHeight !== lastScrollHeightRef.current) {
                $iv6Yc._1(fn, undefined);
                lastScrollHeightRef.current = el.scrollHeight;
            }
            $iv6Yc._1($$clearTimeout, undefined);
            loop(undefined);
        }, 100);
    };
    $g85JO.useEffect(function() {
        loop(undefined);
    }, []);
}
function $2838e4065aa467f6$export$3d0b964c6901b06d(param) {
    var id = "smartnav-overflow-anchor-style";
    $g85JO.useEffect(function() {
        var style = document.getElementById(id);
        if (style == null) {
            var arg = document.createTextNode("body { overflow-anchor: none; }");
            var arg$1 = $dLC6y.tap($dLC6y.tap(document.createElement("style"), function(__x) {
                __x.setAttribute("id", id);
            }), function(param) {
                param.appendChild(arg);
            });
            $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
                param.appendChild(arg$1);
            });
        }
        return function(param) {
            var style = document.getElementById(id);
            if (!(style == null)) {
                style.remove();
                return;
            }
        };
    }, []);
}
function $2838e4065aa467f6$export$6f91e7af12d0519b(idOpt, offset, embedHeight, param) {
    var id = idOpt !== undefined ? idOpt : "global";
    $2838e4065aa467f6$export$3d0b964c6901b06d(undefined);
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var timeout1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var timeout2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var isOverlay = function isOverlay(param) {
        if ($2whNH.isSome($kJhYp.getStatesByNamespace(namespace).current.quickView.mediaId)) return true;
        else return $2whNH.mapWithDefault($kJhYp.getStatesByNamespace(namespace).current.quickNav, false, function(loc) {
            return $2whNH.isSome(loc.productId);
        });
    };
    var offsetRef = $g85JO.useRef(0);
    var previousScroll = $g85JO.useRef(0);
    var updatePreviousScroll = function updatePreviousScroll(scrollY) {
        var willUpdate = !isOverlay(undefined) && !$2838e4065aa467f6$export$51e57029e6716073(undefined);
        previousScroll.current = willUpdate ? scrollY : previousScroll.current;
    };
    var getCurrentKey = function getCurrentKey(param) {
        return $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    };
    var getSavedScrollY = function getSavedScrollY(localStorageOpt, offset) {
        var localStorage = localStorageOpt !== undefined ? localStorageOpt : false;
        var match = $2XXXw.getScroll(namespace, localStorage, id);
        var match$1 = !isOverlay(undefined);
        if (typeof match !== "number" && match.TAG === /* Pixels */ 0) {
            if (match$1 && previousScroll.current >= offset) return Math.max(match._0, offset);
            else return;
        }
        if (match$1 && previousScroll.current >= offset) return $2XXXw.getClosestBreakingPoint(previousScroll.current, offset);
    };
    var scrollTo = function scrollTo(y) {
        window.scrollTo(0.0, y);
    };
    var applyScroll = function applyScroll(param) {
        var savedScrollY = getSavedScrollY(undefined, offsetRef.current);
        var currentScrollY = $dLC6y.tap($iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0, updatePreviousScroll);
        if (savedScrollY !== undefined && savedScrollY !== currentScrollY) return scrollTo(savedScrollY);
    };
    var lastKey = $g85JO.useRef(getCurrentKey(undefined));
    $2838e4065aa467f6$export$85c5d4ae50531531(function(param) {
        if ($2838e4065aa467f6$export$51e57029e6716073(undefined)) return applyScroll(undefined);
    });
    var applyOnLocationChange = function applyOnLocationChange(offset) {
        offsetRef.current = offset;
        var apply = function apply(param) {
            var currentKey = getCurrentKey(undefined);
            var savedScrollY = getSavedScrollY(undefined, offset);
            if (savedScrollY !== undefined && lastKey.current !== currentKey) {
                $2838e4065aa467f6$export$aded8d3ce7fe43e1(true);
                scrollTo(savedScrollY);
                timeout1.setTimeout(function(param) {
                    applyScroll(undefined);
                    timeout2.setTimeout(function(param) {
                        $2838e4065aa467f6$export$aded8d3ce7fe43e1(false);
                    }, 100);
                }, 0);
            }
            lastKey.current = currentKey;
        };
        var removePreviousCallback = function removePreviousCallback(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.keep($kJhYp.getStatesByNamespace(namespace).localCallbacks, function(fn) {
                return fn !== apply;
            }));
        };
        var addCallback = function addCallback(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.concat($kJhYp.getStatesByNamespace(namespace).localCallbacks, [
                apply
            ]));
        };
        removePreviousCallback(undefined);
        addCallback(undefined);
        return function(param) {
            removePreviousCallback(undefined);
        };
    };
    var saveOnScroll = function saveOnScroll(offset) {
        var save = function save(param) {
            var currentScroll = $dLC6y.tap($iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0, updatePreviousScroll);
            if ($2838e4065aa467f6$export$51e57029e6716073(undefined)) return $2XXXw.ScrollRestorationLocalStorage.set(id, {
                TAG: /* Pixels */ 0,
                _0: offset
            });
            else return $2XXXw.setCurrentScroll(namespace, id, {
                TAG: /* Pixels */ 0,
                _0: currentScroll
            });
        };
        var removePreviousListener = function removePreviousListener(param) {
            window.removeEventListener("scroll", save, {
                capture: false,
                passive: true
            });
        };
        var addListener = function addListener(param) {
            window.addEventListener("scroll", save, {
                capture: false,
                passive: true,
                once: false
            });
        };
        removePreviousListener(undefined);
        addListener(undefined);
        return removePreviousListener;
    };
    var cachedCleanupFns = $g85JO.useRef({});
    var runSparingly = function runSparingly(fn) {
        var fnName = fn.name;
        var isInitialized = function isInitialized(param) {
            return $2whNH.isSome($d3YYW.get(cachedCleanupFns.current, fnName));
        };
        var initialize = function initialize(cleanupFn) {
            cachedCleanupFns.current = $d3YYW.fromArray($i7mYY.concat($d3YYW.entries(cachedCleanupFns.current), [
                [
                    fnName,
                    cleanupFn
                ]
            ]));
        };
        if (offset !== undefined && !isInitialized(undefined)) initialize($iv6Yc._1(fn, offset));
    };
    var cleanUp = function cleanUp(param) {
        $i7mYY.forEach($i7mYY.keepMap($d3YYW.values(cachedCleanupFns.current), function(v) {
            return v;
        }), function(cleanUp) {
            $iv6Yc._1(cleanUp, undefined);
        });
    };
    $g85JO.useEffect(function() {
        return runSparingly(saveOnScroll);
    }, [
        offset
    ]);
    $g85JO.useEffect(function() {
        return runSparingly(applyOnLocationChange);
    }, [
        offset
    ]);
    $g85JO.useEffect(function() {
        return cleanUp;
    }, []);
    $25dxq.useBrowserNavigation(function(navigationType) {
        var offset$1 = $2whNH.getWithDefault(offset, 0);
        var embedHeight$1 = $2whNH.getWithDefault(embedHeight, 0);
        var totalEmbedHeight = offset$1 + embedHeight$1 | 0;
        var px = $2XXXw.getScroll(namespace, true, id);
        var pxToScroll;
        pxToScroll = typeof px === "number" || px.TAG !== /* Pixels */ 0 ? undefined : px._0;
        if (navigationType !== 1) return $2XXXw.ScrollRestorationLocalStorage.$$delete(id);
        else if (pxToScroll !== undefined && pxToScroll > ($iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0) && pxToScroll < totalEmbedHeight) return scrollTo(pxToScroll);
        else return;
    }, [
        offset,
        embedHeight
    ]);
}
 /*  Not a pure module */ 
});



parcelRegister("jQE31", function(module, exports) {

$parcel$export(module.exports, "emptyHook", function () { return $e731f04e5e6b50ef$export$2ab9500c85113902; });
$parcel$export(module.exports, "Context", function () { return $e731f04e5e6b50ef$export$841858b892ce1f4c; });
$parcel$export(module.exports, "usePrimaryNavbarHeightSetter", function () { return $e731f04e5e6b50ef$export$74c789e9f40a8cd5; });
$parcel$export(module.exports, "useSecondaryNavbarHeightSetter", function () { return $e731f04e5e6b50ef$export$7483ed169fd54951; });
$parcel$export(module.exports, "useToolbarHeightSetter", function () { return $e731f04e5e6b50ef$export$6c1f62a4c1614cf3; });
$parcel$export(module.exports, "useSubMenuSliderHeightSetter", function () { return $e731f04e5e6b50ef$export$f7750f20663cff17; });
$parcel$export(module.exports, "useTitleHeightSetter", function () { return $e731f04e5e6b50ef$export$955fb9e586ae4adb; });
$parcel$export(module.exports, "make", function () { return $e731f04e5e6b50ef$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $cTjaa = parcelRequire("cTjaa");

var $lx43R = parcelRequire("lx43R");

var $1CxxQ = parcelRequire("1CxxQ");
function $e731f04e5e6b50ef$export$2ab9500c85113902(param) {
    return 0;
}
var $e731f04e5e6b50ef$var$context = /*#__PURE__*/ $g85JO.createContext({
    state: {
        primaryNavbarHeight: 0,
        secondaryNavbarHeight: 0,
        fixedSecondaryNavbarHeight: 0,
        dynamicSecondaryNavbarHeight: 0,
        toolbarHeight: 0,
        subMenuSliderHeight: 0,
        titleHeight: 0,
        showPrimaryNavbar: true,
        anchorsOffset: []
    },
    setState: function setState(param) {}
});
var $e731f04e5e6b50ef$var$provider = $e731f04e5e6b50ef$var$context.Provider;
function $e731f04e5e6b50ef$var$ListPageLayoutController$Context$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($e731f04e5e6b50ef$var$provider, {
        value: value,
        children: children
    });
}
$e731f04e5e6b50ef$var$ListPageLayoutController$Context$Provider.displayName = "ListPageLayoutController.Context.Provider";
var $e731f04e5e6b50ef$var$Provider = {
    provider: $e731f04e5e6b50ef$var$provider,
    make: $e731f04e5e6b50ef$var$ListPageLayoutController$Context$Provider
};
function $e731f04e5e6b50ef$var$use(param) {
    return $g85JO.useContext($e731f04e5e6b50ef$var$context);
}
var $e731f04e5e6b50ef$export$841858b892ce1f4c = {
    context: $e731f04e5e6b50ef$var$context,
    Provider: $e731f04e5e6b50ef$var$Provider,
    use: $e731f04e5e6b50ef$var$use
};
function $e731f04e5e6b50ef$var$ListPageLayoutController(Props) {
    var onChange = Props.onChange;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var autoHidePrimaryNavbarOpt = Props.autoHidePrimaryNavbar;
    var children = Props.children;
    var autoHidePrimaryNavbar = autoHidePrimaryNavbarOpt !== undefined ? autoHidePrimaryNavbarOpt : true;
    var match = $1CxxQ.use(undefined);
    var embedOffsetTop = match.embedOffsetTop;
    var match$1 = $g85JO.useState(function() {
        return {
            primaryNavbarHeight: 0,
            secondaryNavbarHeight: 0,
            fixedSecondaryNavbarHeight: 0,
            dynamicSecondaryNavbarHeight: 0,
            toolbarHeight: 0,
            subMenuSliderHeight: 0,
            titleHeight: 0,
            showPrimaryNavbar: true,
            anchorsOffset: []
        };
    });
    var setState = match$1[1];
    var state = match$1[0];
    var updateAnchorsOffset = function updateAnchorsOffset(state) {
        var anchorsOffset = state.showPrimaryNavbar ? [
            state.primaryNavbarHeight,
            state.secondaryNavbarHeight,
            state.toolbarHeight,
            $2whNH.getWithDefault(embedOffsetTop, 0)
        ] : [
            state.secondaryNavbarHeight,
            state.toolbarHeight,
            $2whNH.getWithDefault(embedOffsetTop, 0)
        ];
        return {
            primaryNavbarHeight: state.primaryNavbarHeight,
            secondaryNavbarHeight: state.secondaryNavbarHeight,
            fixedSecondaryNavbarHeight: state.fixedSecondaryNavbarHeight,
            dynamicSecondaryNavbarHeight: state.dynamicSecondaryNavbarHeight,
            toolbarHeight: state.toolbarHeight,
            subMenuSliderHeight: state.subMenuSliderHeight,
            titleHeight: state.titleHeight,
            showPrimaryNavbar: state.showPrimaryNavbar,
            anchorsOffset: anchorsOffset
        };
    };
    var setState$1 = $g85JO.useCallback(function(fn) {
        $iv6Yc._1(setState, function(previous) {
            var nextState = $iv6Yc._1(fn, previous);
            var nextState$1 = updateAnchorsOffset(nextState);
            $2whNH.forEach(onChange, function(fn) {
                $iv6Yc._1(fn, nextState$1);
            });
            return nextState$1;
        });
    }, [
        setState
    ]);
    var match$2 = $lx43R.useScrollable($2whNH.isSome(scrollableContainerRef) && autoHidePrimaryNavbar, scrollableContainerRef !== undefined ? $loT9g.nullable_to_opt(scrollableContainerRef.current) : undefined, undefined, undefined, undefined);
    var match$3 = $lx43R.useWindow($2whNH.isNone(scrollableContainerRef) && autoHidePrimaryNavbar, undefined, undefined, undefined, undefined);
    var scrollDirection = scrollableContainerRef !== undefined ? match$2[0] : match$3[0];
    $g85JO.useEffect(function() {
        if (autoHidePrimaryNavbar) $iv6Yc._1(setState$1, function(previous) {
            return {
                primaryNavbarHeight: previous.primaryNavbarHeight,
                secondaryNavbarHeight: previous.secondaryNavbarHeight,
                fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
                dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
                toolbarHeight: previous.toolbarHeight,
                subMenuSliderHeight: previous.subMenuSliderHeight,
                titleHeight: previous.titleHeight,
                showPrimaryNavbar: scrollDirection === /* Up */ 0,
                anchorsOffset: previous.anchorsOffset
            };
        });
    }, [
        scrollDirection
    ]);
    var value = $g85JO.useMemo(function() {
        return {
            state: state,
            setState: setState$1
        };
    }, [
        state,
        setState$1
    ]);
    return /*#__PURE__*/ $g85JO.createElement($e731f04e5e6b50ef$var$ListPageLayoutController$Context$Provider, {
        value: value,
        children: children
    });
}
$e731f04e5e6b50ef$var$ListPageLayoutController.displayName = "ListPageLayoutController";
function $e731f04e5e6b50ef$export$378e547978855504(logKey, ref, setter) {
    var size = $cTjaa.useResizeObserver(undefined, ref);
    var height = $2whNH.mapWithDefault(size, 0, function(size) {
        return size.height;
    });
    var match = $g85JO.useContext($e731f04e5e6b50ef$var$context);
    var setState = match.setState;
    var log2 = function log2(info1, info2) {
        $2whNH.forEach(logKey, function(param) {
            console.log("LPLC:setter", info1, info2, param);
        });
    };
    $g85JO.useEffect(function() {
        log2(height, ref.current);
        $iv6Yc._1(setState, $iv6Yc._1(setter, height));
        return function(param) {
            log2(0, ref.current);
            $iv6Yc._1(setState, $iv6Yc._1(setter, 0));
        };
    }, [
        height
    ]);
    return height;
}
function $e731f04e5e6b50ef$export$74c789e9f40a8cd5(ref) {
    return $e731f04e5e6b50ef$export$378e547978855504(undefined, ref, function(height, previous) {
        return {
            primaryNavbarHeight: height,
            secondaryNavbarHeight: previous.secondaryNavbarHeight,
            fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
            dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
            toolbarHeight: previous.toolbarHeight,
            subMenuSliderHeight: previous.subMenuSliderHeight,
            titleHeight: previous.titleHeight,
            showPrimaryNavbar: previous.showPrimaryNavbar,
            anchorsOffset: previous.anchorsOffset
        };
    });
}
function $e731f04e5e6b50ef$export$7483ed169fd54951(isFixed, ref) {
    return $e731f04e5e6b50ef$export$378e547978855504(undefined, ref, function(height, previous) {
        return {
            primaryNavbarHeight: previous.primaryNavbarHeight,
            secondaryNavbarHeight: height,
            fixedSecondaryNavbarHeight: isFixed ? height : previous.fixedSecondaryNavbarHeight,
            dynamicSecondaryNavbarHeight: isFixed ? previous.dynamicSecondaryNavbarHeight : height,
            toolbarHeight: previous.toolbarHeight,
            subMenuSliderHeight: previous.subMenuSliderHeight,
            titleHeight: previous.titleHeight,
            showPrimaryNavbar: previous.showPrimaryNavbar,
            anchorsOffset: previous.anchorsOffset
        };
    });
}
function $e731f04e5e6b50ef$export$6c1f62a4c1614cf3(ref) {
    return $e731f04e5e6b50ef$export$378e547978855504(undefined, ref, function(height, previous) {
        return {
            primaryNavbarHeight: previous.primaryNavbarHeight,
            secondaryNavbarHeight: previous.secondaryNavbarHeight,
            fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
            dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
            toolbarHeight: height,
            subMenuSliderHeight: previous.subMenuSliderHeight,
            titleHeight: previous.titleHeight,
            showPrimaryNavbar: previous.showPrimaryNavbar,
            anchorsOffset: previous.anchorsOffset
        };
    });
}
function $e731f04e5e6b50ef$export$f7750f20663cff17(ref) {
    return $e731f04e5e6b50ef$export$378e547978855504(undefined, ref, function(height, previous) {
        return {
            primaryNavbarHeight: previous.primaryNavbarHeight,
            secondaryNavbarHeight: previous.secondaryNavbarHeight,
            fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
            dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
            toolbarHeight: previous.toolbarHeight,
            subMenuSliderHeight: height,
            titleHeight: previous.titleHeight,
            showPrimaryNavbar: previous.showPrimaryNavbar,
            anchorsOffset: previous.anchorsOffset
        };
    });
}
function $e731f04e5e6b50ef$export$955fb9e586ae4adb(ref) {
    return $e731f04e5e6b50ef$export$378e547978855504(undefined, ref, function(height, previous) {
        return {
            primaryNavbarHeight: previous.primaryNavbarHeight,
            secondaryNavbarHeight: previous.secondaryNavbarHeight,
            fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
            dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
            toolbarHeight: previous.toolbarHeight,
            subMenuSliderHeight: previous.subMenuSliderHeight,
            titleHeight: height,
            showPrimaryNavbar: previous.showPrimaryNavbar,
            anchorsOffset: previous.anchorsOffset
        };
    });
}
var $e731f04e5e6b50ef$export$dd44f18ab656f3bb = $e731f04e5e6b50ef$var$ListPageLayoutController;
 /* context Not a pure module */ 
});
parcelRegister("1CxxQ", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $12e35c630347b6ad$export$2881499e37b75b9a; });
$parcel$export(module.exports, "use", function () { return $12e35c630347b6ad$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $cTjaa = parcelRequire("cTjaa");

var $lkFoc = parcelRequire("lkFoc");
var $12e35c630347b6ad$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext({
    embedContainer: undefined,
    embedOffsetTop: undefined
});
var $12e35c630347b6ad$var$provider = $12e35c630347b6ad$export$a078c61943f9dbbe.Provider;
function $12e35c630347b6ad$var$InlineContainerContext$Provider(Props) {
    var embedRef = Props.embedRef;
    var children = Props.children;
    var embedSize = $cTjaa.useResizeObserver(true, embedRef);
    var embedOffsetTop = $2whNH.map(embedSize, function(size) {
        return size.top;
    });
    var embedHeight = $2whNH.map(embedSize, function(size) {
        return size.height;
    });
    var embedContainer = embedRef.current;
    var embedContainer$1 = embedContainer == null ? undefined : $loT9g.some(embedContainer);
    $lkFoc.useInlineHelper(embedContainer$1, embedHeight, embedOffsetTop);
    return /*#__PURE__*/ $g85JO.createElement($12e35c630347b6ad$var$provider, {
        value: {
            embedContainer: embedContainer$1,
            embedOffsetTop: embedOffsetTop
        },
        children: children
    });
}
$12e35c630347b6ad$var$InlineContainerContext$Provider.displayName = "InlineContainerContext.Provider";
var $12e35c630347b6ad$export$2881499e37b75b9a = {
    provider: $12e35c630347b6ad$var$provider,
    make: $12e35c630347b6ad$var$InlineContainerContext$Provider
};
function $12e35c630347b6ad$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($12e35c630347b6ad$export$a078c61943f9dbbe);
}
 /* context Not a pure module */ 
});
parcelRegister("lkFoc", function(module, exports) {

$parcel$export(module.exports, "useInlineHelper", function () { return $f87b924868a4ae6c$export$5e62d141f4af6487; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $avqDR = parcelRequire("avqDR");

var $7GW0c = parcelRequire("7GW0c");

var $8E2YL = parcelRequire("8E2YL");

var $3s6k1 = parcelRequire("3s6k1");

var $gUsPc = parcelRequire("gUsPc");
function $f87b924868a4ae6c$export$5e62d141f4af6487(embedContainer, embedHeight, embedOffsetTop) {
    var siteHeaderHeight = $gUsPc.useStrict(undefined);
    var match = $8E2YL.use(undefined).config;
    var account = match.transitiveAccount;
    var settings = match.settings;
    $3s6k1.useGlobalScrollRestoration("global-" + match.id, $2whNH.map(embedOffsetTop, function(embedOffsetTop) {
        return Math.max(embedOffsetTop - siteHeaderHeight | 0, 0);
    }), embedHeight, undefined);
    var resetOverflowOnAncestorElements = function resetOverflowOnAncestorElements(el) {
        var parent = $loT9g.nullable_to_opt(el.parentElement);
        while($2whNH.isSome(parent)){
            var computedStyles = $2whNH.map(parent, function(el) {
                return window.getComputedStyle(el);
            });
            var overflow = $2whNH.map(computedStyles, function(styles) {
                return styles.overflow;
            });
            if ($7bjme.notequal(overflow, "visible") && $7bjme.notequal(overflow, "visible visible")) $2whNH.forEach(parent, function(el) {
                $7GW0c.setStyle(el, "overflow", "clip visible");
            });
            parent = $2whNH.flatMap(parent, function(prim) {
                return $loT9g.nullable_to_opt(prim.parentElement);
            });
        }
    };
    $g85JO.useEffect(function() {
        var match = $avqDR.getSiteHeaderCSSSelector(settings, account);
        if (embedContainer !== undefined && match !== undefined) resetOverflowOnAncestorElements($loT9g.valFromOption(embedContainer));
    }, [
        embedContainer
    ]);
}
 /* react Not a pure module */ 
});



})();
//# sourceMappingURL=PDPApp.bs.67e6d489.js.map
